module.exports = __webpack_public_path__ + "static/media/logo_terra.72e742cf.svg";